import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import api from "../api/api";
import { Helmet } from "react-helmet-async";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";
import contactImg from "../assets/images/aboutUs.jpg";


export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const res = await api.get("/blogs");
        const data = res.data;

        setBlogs(data);

        const uniqueCategories = [
          ...new Map(
            data
              .filter((b) => b.category)
              .map((b) => [b.category.id, b.category])
          ).values(),
        ];

        setCategories(uniqueCategories);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter((blog) => {
    const matchesSearch = blog.title
      .toLowerCase()
      .includes(search.toLowerCase());

    const matchesCategory = selectedCategory
      ? blog.category?.id === Number(selectedCategory)
      : true;

    return matchesSearch && matchesCategory;
  });

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Travel Blog | UAE Dubai Hotels</title>

        <meta
          name="description"
          content="Explore the UAE Dubai Hotels blog for expert travel guides, hotel recommendations, Dubai attractions, luxury stays, budget accommodations, and the latest hotel deals across the UAE."
        />

        <meta
          name="keywords"
          content="UAE Dubai Hotels blog, Dubai travel guide, UAE hotels, luxury hotels Dubai, budget hotels UAE, hotel booking UAE, Dubai accommodation, travel tips Dubai, UAE travel blog"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="UAE Dubai Hotels" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://uaedubaihotels.com/blogs"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="UAE Dubai Hotels" />
        <meta property="og:locale" content="en_US" />

        <meta
          property="og:title"
          content="Travel Blog | UAE Dubai Hotels"
        />

        <meta
          property="og:description"
          content="Read expert travel guides, hotel reviews, destination insights, and exclusive hotel deals across Dubai and the UAE."
        />

        <meta
          property="og:url"
          content="https://uaedubaihotels.com/blogs"
        />

        <meta
          property="og:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Travel Blog | UAE Dubai Hotels"
        />

        <meta
          name="twitter:description"
          content="Discover travel tips, hotel reviews, destination guides, and exclusive hotel offers across Dubai and the UAE."
        />

        <meta
          name="twitter:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />
      </Helmet>

      <div className="w-full bg-gray-50 dark:bg-gray-950">

        <section
          className="
  relative
  h-[380px]
  md:h-[420px]
  flex
  items-center
  bg-cover
  bg-center
  "
          style={{
            backgroundImage:
              `linear-gradient(rgba(0,0,0,.65),rgba(0,0,0,.65)), url(${contactImg})`
          }}
        >


          <div className="
  container
  mx-auto
  px-6
  text-white
  ">


            <p className="
    uppercase
    tracking-[0.3em]
    text-[#D4B76A]
    text-sm
    mb-5
    ">
              UAE Travel Journal
            </p>



            <h1
              className="
        text-2xl
        sm:text-3xl
        md:text-5xl
        font-serif
        max-w-3xl
        leading-tight
    "
            >
              Discover UAE Stories,
              Travel Guides & Hotel Experiences
            </h1>



            <p className="
    mt-5
    max-w-xl
    text-white/80
    leading-relaxed
    ">
              Explore Dubai, Abu Dhabi and the UAE through
              expert travel tips, hotel recommendations,
              destination guides and unforgettable experiences.
            </p>



          </div>


        </section>


        <div className="container mx-auto px-4 md:px-6 py-16 lg:py-24">

          {/* ================= TOP FILTER BAR ================= */}

          <div className="relative overflow-hidden rounded-[35px] bg-gradient-to-r from-[#0F172A] via-[#111827] to-[#1F2937] p-8 lg:p-10 mb-14 shadow-2xl">

            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#D9BB74]/10 blur-3xl"></div>

            <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-blue-500/10 blur-3xl"></div>

            <div className="relative z-10">

              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">

                <div className="max-w-2xl">

                  <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D9BB74]/20 text-[#D9BB74] text-sm font-semibold tracking-wide uppercase">

                    ✦ Travel Magazine

                  </span>

                  <h2 className="mt-5 text-4xl md:text-5xl font-bold text-white leading-tight">

                    Explore Stories That Inspire Your Next UAE Adventure

                  </h2>

                  <p className="mt-5 text-gray-300 leading-relaxed">

                    Browse expert travel guides, luxury hotels, hidden gems,
                    destination ideas and exclusive accommodation tips from
                    across Dubai, Abu Dhabi and the Emirates.

                  </p>

                </div>

                <div className="lg:w-[420px]">

                  <div className="bg-white/10 backdrop-blur-xl border border-white/10 rounded-3xl p-6">

                    <label className="text-white font-semibold mb-3 block">

                      Search Articles

                    </label>

                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search destinations, hotels..."
                      className="w-full h-14 rounded-2xl bg-white/10 border border-white/10 text-white placeholder:text-gray-400 px-5 outline-none focus:border-[#D9BB74] transition"
                    />

                    <div className="mt-6">

                      <p className="text-white text-sm mb-3">

                        Categories

                      </p>

                      <div className="flex flex-wrap gap-2">

                        <button
                          onClick={() => setSelectedCategory("")}
                          className={`px-4 py-2 rounded-full text-sm transition
                  ${selectedCategory === ""
                              ? "bg-[#D9BB74] text-black font-semibold"
                              : "bg-white/10 text-white hover:bg-white/20"
                            }`}
                        >
                          All Stories
                        </button>

                        {categories.map((cat) => (
                          <button
                            key={cat.id}
                            onClick={() => setSelectedCategory(cat.id)}
                            className={`px-4 py-2 rounded-full text-sm transition
                    ${selectedCategory === cat.id
                                ? "bg-[#D9BB74] text-black font-semibold"
                                : "bg-white/10 text-white hover:bg-white/20"
                              }`}
                          >
                            {cat.name}
                          </button>
                        ))}

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

          {/* ================= FEATURED STORY ================= */}

          {filteredBlogs.length > 0 && (

            <Link to={`/blogs/${filteredBlogs[0].slug}`}>

              <section className="grid lg:grid-cols-2 gap-10 items-center mb-20">

                <div className="relative group rounded-[35px] overflow-hidden shadow-2xl h-[550px]">

                  <img
                    src={filteredBlogs[0].thumbnail_image}
                    alt={filteredBlogs[0].title}
                    className="w-full h-full object-cover transition duration-700 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent"></div>

                  <div className="absolute top-6 left-6">

                    <span className="px-5 py-2 rounded-full bg-[#D9BB74] text-black text-xs font-bold uppercase tracking-wider">

                      Featured Story

                    </span>

                  </div>

                </div>

                <div>

                  <span className="inline-flex px-4 py-2 rounded-full bg-[#D9BB74]/20 text-[#D9BB74] font-semibold">

                    {filteredBlogs[0].category?.name || "Travel"}

                  </span>

                  <h2 className="mt-6 text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white leading-tight">

                    {filteredBlogs[0].title}

                  </h2>

                  <p className="mt-6 text-gray-600 dark:text-gray-400 leading-8 text-lg line-clamp-4">

                    {filteredBlogs[0].excerpt}

                  </p>

                  <div className="flex flex-wrap items-center gap-6 mt-8">

                    <div>

                      <p className="text-sm text-gray-500">

                        Published

                      </p>

                      <p className="font-semibold text-gray-900 dark:text-white">

                        {new Date(filteredBlogs[0].created_at).toDateString()}

                      </p>

                    </div>

                    <div className="w-px h-12 bg-gray-300 dark:bg-gray-700"></div>

                    <div>

                      <p className="text-sm text-gray-500">

                        Category

                      </p>

                      <p className="font-semibold text-gray-900 dark:text-white">

                        {filteredBlogs[0].category?.name || "Travel"}

                      </p>

                    </div>

                  </div>

                  <button className="mt-10 px-8 py-4 rounded-2xl bg-[#D9BB74] hover:bg-[#cba960] transition font-semibold text-black shadow-xl">

                    Read Full Story →

                  </button>

                </div>

              </section>

            </Link>

          )}

          {/* BLOG GRID STARTS BELOW */}





          {/* ===================== BLOG GRID ===================== */}

          <div className="mb-10 flex items-center justify-between">

            <div>

              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
                Latest Articles
              </h2>

              <p className="mt-2 text-gray-600 dark:text-gray-400">
                Discover expert travel tips, destination guides and hotel recommendations.
              </p>

            </div>

            <div className="hidden md:flex items-center gap-2 px-5 py-3 rounded-full bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-gray-800">

              <span className="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse"></span>

              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {filteredBlogs.length} Articles
              </span>

            </div>

          </div>

          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">

            {filteredBlogs.slice(1).map((blog) => (

              <Link
                key={blog.id}
                to={`/blogs/${blog.slug}`}
                className="group"
              >

                <article
                  className="
        overflow-hidden
        rounded-[30px]
        bg-white
        dark:bg-gray-900
        border
        border-gray-200
        dark:border-gray-800
        shadow-lg
        hover:shadow-2xl
        transition-all
        duration-500
        hover:-translate-y-2
      "
                >

                  {/* IMAGE */}

                  <div className="relative overflow-hidden h-64">

                    <img
                      src={blog.thumbnail_image}
                      alt={blog.title}
                      className="
            w-full
            h-full
            object-cover
            duration-700
            group-hover:scale-110
          "
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                    <div className="absolute top-5 left-5">

                      <span className="
            bg-[#D9BB74]
            text-black
            px-4
            py-2
            rounded-full
            text-xs
            uppercase
            font-bold
            tracking-wider
          ">

                        {blog.category?.name || "Travel"}

                      </span>

                    </div>

                    <div className="absolute bottom-5 right-5">

                      <div className="
            w-12
            h-12
            rounded-full
            bg-white/20
            backdrop-blur-md
            border
            border-white/30
            flex
            items-center
            justify-center
            text-white
            group-hover:bg-[#D9BB74]
            group-hover:text-black
            transition
          ">
                        →
                      </div>

                    </div>

                  </div>

                  {/* CONTENT */}

                  <div className="p-7">

                    <div className="flex items-center justify-between mb-4">

                      <span className="text-sm text-gray-500 dark:text-gray-400">
                        {new Date(blog.created_at).toDateString()}
                      </span>

                      <span className="
            text-xs
            px-3
            py-1
            rounded-full
            bg-green-100
            dark:bg-green-900/30
            text-green-700
            dark:text-green-400
            font-medium
          ">
                        New
                      </span>

                    </div>

                    <h3 className="
          text-2xl
          font-bold
          text-gray-900
          dark:text-white
          leading-snug
          line-clamp-2
          group-hover:text-[#D9BB74]
          transition
        ">

                      {blog.title}

                    </h3>

                    <p className="
          mt-4
          text-gray-600
          dark:text-gray-400
          leading-7
          line-clamp-3
        ">

                      {blog.excerpt}

                    </p>

                    <div className="
          mt-8
          pt-5
          border-t
          border-gray-200
          dark:border-gray-800
          flex
          justify-between
          items-center
        ">

                      <span className="
            font-semibold
            text-[#D9BB74]
            group-hover:translate-x-2
            transition
          ">
                        Read Article
                      </span>

                      <span className="
            text-gray-400
            group-hover:text-[#D9BB74]
            transition
            text-xl
          ">
                        →
                      </span>

                    </div>

                  </div>

                </article>

              </Link>

            ))}

          </div>

          {/* EMPTY STATE */}

          {filteredBlogs.length === 0 && (

            <div className="
  py-28
  text-center
  rounded-[35px]
  bg-white
  dark:bg-gray-900
  border
  border-dashed
  border-gray-300
  dark:border-gray-700
">

              <div className="text-6xl mb-6">
                🔍
              </div>

              <h3 className="text-3xl font-bold text-gray-900 dark:text-white">

                No Articles Found

              </h3>

              <p className="mt-4 text-gray-500 dark:text-gray-400 max-w-lg mx-auto">

                We couldn't find any articles matching your search or selected
                category. Try another keyword or browse all stories.

              </p>

              <button
                onClick={() => {
                  setSearch("");
                  setSelectedCategory("");
                }}
                className="
      mt-8
      px-8
      py-4
      rounded-2xl
      bg-[#D9BB74]
      hover:bg-[#caa95f]
      transition
      font-semibold
      text-black
    "
              >

                View All Articles

              </button>

            </div>

          )}


        </div>

      </div >
    </>
  );
}